export const LEAD_STATUSES = {
  ARCHIVED: 'archived',
  BOOKED: 'booked',
  LOST: 'lost',
  LEAD_WAITING: 'lead waiting',
} as const;

export type LeadStatus = typeof LEAD_STATUSES[keyof typeof LEAD_STATUSES] | string;

export const DEFAULT_STATUSES = Object.values(LEAD_STATUSES); 